import React, { useState, useEffect } from 'react';
import OrderForm from './components/OrderForm';
import LockedMessage from './components/LockedMessage';
import { getConfig } from './services/api';
import './App.css';

function App() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const configData = await getConfig();
      setConfig(configData);
    } catch (err) {
      setError('Konfiguration konnte nicht geladen werden.');
      console.error('Config load error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="d-flex justify-content-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Laden...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-5">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="app-header text-white py-3 mb-4">
        <div className="container">
          <div className="d-flex align-items-center">
            <a href="https://schulefuchsbergredder.hamburg.de" target="_blank" rel="noopener noreferrer">
              <img
                src={process.env.PUBLIC_URL + '/logo.svg'}
                alt="Schule Fuchsbergredder Logo"
                className="header-logo me-3"
              />
            </a>
            <div>
              <h1 className="mb-0 fs-3">Schule Fuchsbergredder Bestellung</h1>
              <p className="mb-0 mt-1 opacity-75">Bestellformular für T-Shirts, Sweatjacken und andere Produkte</p>
            </div>
          </div>
        </div>
      </header>

      <main className="container pb-5">
        {config?.form_locked ? (
          <LockedMessage message={config.lock_message} />
        ) : (
          <OrderForm config={config} />
        )}
      </main>

      <footer className="app-footer py-3 mt-5">
        <div className="container text-center">
          <small>Schule Fuchsbergredder - Schulkleidung {config?.schuljahr}</small>
        </div>
      </footer>
    </div>
  );
}

export default App;
